import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ConfService} from '../../conf.service';
import {EmailtemplateService} from '../../emailtemplate.service';
import {MatRadioChange} from '@angular/material';

declare let $;

@Component({
  selector: 'app-password-manager',
  templateUrl: './password-manager.component.html',
  styleUrls: ['./password-manager.component.scss']
})
export class PasswordManagerComponent implements OnInit, OnChanges {

  @Input() partner = '';
  @Input() account = '';
  @Input() showConfigureButton: boolean;
  @Input() vault: any;

  // Just for the UI Change in signup
  @Input() isSignup = false;

  account_password: any;
  selectedVault: any;
  vaultSelected: '';

  // vaults = [
  //   {
  //     'name': 'Default',
  //     'logo': './assets/img/partnerOnboarding/api.png',
  //     'description': 'apiplatform\'s encryption mechanism'
  //   },
  //   {
  //     'name': 'AWS Secrets Manager',
  //     'logo': './assets/img/partnerOnboarding/awsSecretsMng.png',
  //     'description': 'Secure your password through AWS Secrets manager'
  //   },
  //   {
  //     'name': 'Hashicorp Vault',
  //     'logo': './assets/img/partnerOnboarding/hashiCorpVault.jpg',
  //     'description': 'Secure your password in Hashicorp\'s vault'
  //   },
  // ];

  vaults = [
    {
      'name': 'Default',
      'providerName': 'apiplatform.io',
      'image': './assets/img/partnerOnboarding/api.png',
      'description': 'apiplatform\'s encryption mechanism',
      'owner': 'apiplatform.io'
    }
  ];

  constructor(private confPost: ConfService, private emailTemplateInstance: EmailtemplateService) { }

  ngOnInit() {

    this.confPost.getData('services', 'services', 'v1', 'secretmanagers', 'partner=services&account=services&fields=providerName,image').subscribe(data => {
      const iterator = data[Symbol.iterator]();
      while (true) {
        const tempObject = iterator.next();
        if (tempObject.done) {
          break;
        }
        this.vaults.push(tempObject.value);
      }
      if (!this.isSignup) {
        this.confPost.getData('services', 'services', 'v1', 'secretmanagers', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&fields=providerName,image').subscribe(data1 => {
          while (true) {
            const tempObject = iterator.next();
            if (tempObject.done) {
              break;
            }
            this.vaults.push(tempObject.value);
          }
        });
      }
    });

    this.selectedVault = this.vaults[0];

    if (this.vault !== undefined) {
      for(let i = 0; i < this.vaults.length ; i++ ){
        if (this.vault === this.vaults[i].name) {
          this.selectedVault = this.vaults[i];
          const id = '#vault' + i;
          $(document).ready(function () {
            $(id).css('border', '2px solid #ff672d');
          });
        }
      }
    } else {
      $(document).ready(function () {
        $('#vault0').css('border', '2px solid #ff672d');
      });
    }
  }

  ngOnChanges() {
  }

  selectVault(event: MatRadioChange) {
  }

  // selectVault(index) {
  //   if (this.vaults[index]['name'] === 'Default') {
  //     this.selectedVault = this.vaults[index];
  //     // this.settingsPayload.partner_settings.vault = this.selectedVault['name'];
  //     for (let i = 0; i < this.vaults.length; i++) {
  //       const id = 'vault' + i;
  //       if (index === i) {
  //         $('#' + id).css('border', '1px solid #ff672d');
  //       } else {
  //         $('#' + id).css('border', 'transparent');
  //       }
  //     }
  //   } else {
  //     alert('Thank you for choosing this service. Use of this service requires additional settings including configuration of payment methods. You can sign up now with default option and change your settings after successfully logging into Platform Console.');
  //     this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].vault = this.vaults[index]['name'];
  //   }
  // }

  configureVaultForFirstTime(pkey, partner, account, password) {
    switch (this.selectedVault['name']) {
      case 'Default':
        this.account_password = password;
        break;
      case 'AWS Secrets Manager':
        const tempPayload = {
          data: {
            password: password
          }
        };
        this.confPost.createSecretInAWSSecretsManager(pkey, partner, account, tempPayload).subscribe(response => {
        });
        break;
      case 'Hashicorp Vault':
        const tempPayload1 = {
          data: {
            password: password
          },
          path: partner + '-' + account + '/login'
        };
        this.confPost.createUserInHashicorpVault(pkey, partner, account).subscribe(response => {
          this.confPost.createSecretInHashicorpVault(pkey, partner, account, tempPayload1).subscribe(response1 => {
          });
        });
    }
  }
}
